export default {"src":"https://images-cdn.curipod.com/d-542d829a/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};